import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[70vh] grid place-items-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md rounded-2xl border border-[#1e5fe0]/25 bg-white/85 p-8 text-center"
        data-testid="payment-cancel-card"
      >
        <span className="grid place-items-center h-16 w-16 rounded-full bg-[#a9772f]/10 border border-[#a9772f]/30 mx-auto mb-4">
          <XCircle className="h-9 w-9 text-[#a9772f]" />
        </span>
        <h1 className="font-serif text-2xl text-[#2e2015]">Pagamento annullato</h1>
        <p className="text-[#6f5c47] mt-2 text-sm">
          Nessun addebito effettuato. Puoi riprovare quando vuoi.
        </p>
        <Button
          data-testid="payment-cancel-back-btn"
          onClick={() => navigate("/credits")}
          className="mt-6 bg-[#1e5fe0] hover:bg-[#2f74f0] text-white font-semibold rounded-full h-11 w-full"
        >
          Torna ai Crediti
        </Button>
      </motion.div>
    </div>
  );
}
